import { render, staticRenderFns } from "./Adminitration_DeliveryVehicle.vue?vue&type=template&id=0abe4e8f"
import script from "./Adminitration_DeliveryVehicle.vue?vue&type=script&lang=js"
export * from "./Adminitration_DeliveryVehicle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports